import React, { useState, useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import Routes from './Routes';
import { AuthProvider } from './contexts/AuthContext';
import { UserSettingsProvider } from './contexts/UserSettingsContext';
import { TeamProvider } from './contexts/TeamContext';
import { SurveyProvider } from './contexts/SurveyContext';
import { RecordingProvider } from './contexts/RecordingContext';
import { LoadingSpinner } from './components/common/LoadingSpinner';
import { ErrorBoundary } from './components/ErrorBoundary';
import { Toast } from './components/common/Toast';
import { logError, logInfo } from '@utils/logger';

const App = () => {
  const [error, setError] = useState(null);
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    const initializeApp = async () => {
      try {
        logInfo('App component mounted');
        setInitialized(true);
        logInfo('App initialization complete');
      } catch (err) {
        logError('App initialization failed:', err);
        setError('Failed to initialize application');
      }
    };

    initializeApp();
  }, []);

  if (!initialized) {
    return (
      <div className="min-h-screen bg-[#3D3F42] flex items-center justify-center p-4">
        <LoadingSpinner />
      </div>
    );
  }

  return (
    <BrowserRouter>
      <ErrorBoundary>
        <React.Suspense fallback={
          <div className="min-h-screen bg-[#3D3F42] flex items-center justify-center p-4">
            <LoadingSpinner />
          </div>
        }>
          <AuthProvider>
            <UserSettingsProvider>
              <TeamProvider>
                <SurveyProvider>
                  <RecordingProvider>
                    <Routes />
                    {error && (
                      <Toast
                        message={error}
                        type="error"
                        onClose={() => setError(null)}
                      />
                    )}
                  </RecordingProvider>
                </SurveyProvider>
              </TeamProvider>
            </UserSettingsProvider>
          </AuthProvider>
        </React.Suspense>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default App;